// Quasar state-manager entry (lifted from go-schedule). Using the
// `defineStore()` wrapper makes Quasar install Pinia (and set it active)
// BEFORE boot files run, so boot files (keycloak, urql → auth/live stores)
// can use stores outside component setup. This is the canonical setup — do
// not also install pinia from a boot file.
//
// Its absence is invisible to vitest (src/test/mount.ts creates its own
// Pinia) and to an HTTP smoke check (index.html still serves) — the failure
// is a blank page with "getActivePinia() was called but there was no active
// Pinia" in the browser console, at boot, in every real session.
import { defineStore } from '#q-app'
import { createPinia } from 'pinia'

export default defineStore(() => {
  const pinia = createPinia()
  return pinia
})
